import React from 'react';

import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { Button,Modal } from 'antd';

import { useWorkJourneyContext } from '@src/packages/workJourney/contexts';

import styles from './WorkJourneyReturnConfirm.module.less';

const WorkJourneyReturnConfirm = () => {
  const intl = useIntl();
  const history = useHistory();
  const { modalVisibility, toggleModalVisibility } = useWorkJourneyContext();

  const handleCancel = () => {
    toggleModalVisibility('returnModal');
  };

  const handleExit = async () => {
    toggleModalVisibility('returnModal');
    await new Promise(resolve => setTimeout(resolve, 300));
    history.go(-1);
  };

  return (
    <Modal
      className={styles.modal}
      open={modalVisibility.returnModal}
      onCancel={handleCancel}
      closable={false}
      title={null}
      width={520}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          {intl.formatMessage({ id: 'button.cancel' })}
        </Button>,
        <Button key="exit" type="primary" onClick={handleExit}>
          {intl.formatMessage({ id: 'workJourney.return.button.exit' })}
        </Button>,
      ]}
    >
      <div className={styles.iconContainer}>
        <span className={`material-icons-outlined ${styles.icon}`}>info</span>
      </div>

      <div className={styles.title}>
        {intl.formatMessage({ id: 'workJourney.return.confirm.title' })}
      </div>

      <div className={styles.description}>
        {intl.formatMessage({ id: 'workJourney.return.confirm.description' })}
      </div>

      <div className={styles.question}>
        {intl.formatMessage({ id: 'workJourney.return.confirm.question' })}
      </div>
    </Modal>
  );
};

export default WorkJourneyReturnConfirm;